<template>
  <div :class="`news-item` + (this.main ? ' main-page-news' : '')">
    <div class="news-item-date">
      <span>{{ value.date }}</span>
    </div>
    <router-link v-if="link" :to="link">{{ value.title }}</router-link>
    <span v-else>{{ value.title }}</span>
    <div class="news-item-text" v-html="this.main ? value.preview : value.text"></div>
  </div>
</template>

<script>
import {computed} from 'vue'
import {useRoute} from 'vue-router'

export default {
  name: 'NewsItem',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    main: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const link = computed(() => {
      const router = useRoute()

      if (router.name === 'news' && router.params.id === props.value.link) {
        return undefined
      }
      return { name: 'news', params: { id: props.value.link } }
    })

    return {
      link
    }
  }
}
</script>

<style scoped>
.news-item {
  margin: 20px 0 10px 0;
}
.news-item > a, .news-item > span {
  text-decoration: unset;
  font-weight: bolder;
  font-size: 18px;
  color: black;
  transition: color 0.2s ease-in-out;
}
.news-item a:hover {
  color: var(--primary-color);
}
.news-item-date {
  margin-bottom: 6px;
  font-size: 14px;
  font-weight: 600;
  color: var(--font-3);
}
.main-page-news .news-item-text {
  font-size: 16px;
  margin-top: 10px;
  width: 100%;
  line-height: 22px;
}
.news-item-text {
  font-size: 16px;
  width: 50%;
  color: var(--font-2);
  margin: auto;
}

</style>
